import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { animatedInputFocus, animatedInputBlur } from 'lib/animated-input';

import Input from 'components/common/input';
import InputPopup from 'components/common/input/popup';
import MailCheck from 'react-mailcheck';


class InputEmail extends React.Component {
  constructor(props) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.useSuggestion = this.useSuggestion.bind(this);
    this.state = { email: null };
  }

  onBlur() {
    this.setState({ email: this.emailField.value });
    animatedInputBlur(this.props.value);
  }

  onChange(e) {
    this.props.onChange(this.props.value, e);
  }

  onFocus() {
    animatedInputFocus(this.props.value);
    if (this.props.error) { this.props.dismissError(this.props.value); }
  }

  useSuggestion() {
    const suggestion = this.mailcheck.state.suggestion.full;
    this.emailField.input.value = suggestion;
    this.setState({ email: suggestion });
  }

  renderEmailSuggestion() {
    return (
      <MailCheck ref={(mailcheck) => { this.mailcheck = mailcheck; }} email={this.state.email}>
        {(suggestion) => {
          if (suggestion) {
            return (<div className="email-suggestion">Did you mean {<span className="suggestion-value" onClick={this.useSuggestion}>{suggestion.full}</span>}?</div>);
          }
          return null;
        }}
      </MailCheck>
    );
  }

  render() {
    const showError = this.props.error && (this.props.showTip ? this.password.value !== '' : true);

    const classNames = cx({
      'animated-input': true,
      'input-error': !!this.props.error,
      'with-suggestion': true,
    });

    return (
      <div className={classNames}>
        { showError ? <InputPopup message={this.props.error} /> : null }
        <Input
          ref={(input) => { this.emailField = input; }}
          value={this.props.value}
          onBlur={this.onBlur}
          onChange={this.onChange}
          onFocus={this.onFocus}
          type="email"
          initialValue={this.props.initialValue}
        />
        <label className="h5-sg text-weight-light">
          <span>{this.props.display}</span>
        </label>
        { this.state.email ? this.renderEmailSuggestion() : null }
      </div>
    );
  }
}

InputEmail.propTypes = {
  // Props
  display: PropTypes.string,
  error: PropTypes.string,
  value: PropTypes.string,
  initialValue: PropTypes.string,
  // Functions
  dismissError: PropTypes.func,
  onChange: PropTypes.func,
};

InputEmail.defaultProps = {
  initialValue: '',
};

export default InputEmail;
